import * as React from 'reactn';
import {ArrayUtil, ComponentFactory, dialog, IBaseDialogProps} from "oca-lib-web";
import DashboardDateUtil from "../util/DashboardDateUtil";
import ExportUtil from "../util/ExportUtil";
import CacheSettings from "../util/CacheSettings";
import Checkbox from '@mui/material/Checkbox';
import ReportUtil from "../util/ReportUtil";
import Styles from "../style/Styles";

interface IState {
    componentFactory:ComponentFactory,
    pages:Array<PageSettings>,
    selectedPages:Array<PageSettings>
}

class ExportDialog extends React.Component<IBaseDialogProps, IState> {

    constructor(props: any) {
        super();

        var componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(this.global.dataManager, null, null);
        componentFactory.setHandleUpdateCallback((value:any, key:string) => {
            this.forceUpdate();
        })

        this.state = {
            componentFactory:componentFactory,
            pages:[],
            selectedPages:[]
        };
        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    componentWillMount() {
        let reportSettings:ReportSettings = this.props.param;
        let pages:Array<any> = [];
        for (let page of reportSettings.pages) {
            pages.push(page);
        }

        let componentFactory = this.state.componentFactory;
        componentFactory.getDefaultBinding().setProperty("downloadOptions", "currentPage");

        this.setState({pages:pages, componentFactory:componentFactory});
    }

    onRowSelection(item: any, data: PageSettings) {
        let selectedPages = this.state.selectedPages;
        let found = false;
        for (let selectedItem of selectedPages) {
            if (data.id == selectedItem.id) {
                found = true;
            }
        }
        if (found) {
            ArrayUtil.deleteItemByKey(data, "id", selectedPages);
        } else {
            selectedPages.push(data);
        }
        this.setState({selectedPages:selectedPages})
    }

    isRowSelected(item:PageSettings):boolean {
        let selectedPages = this.state.selectedPages;
        for (let selectedItem of selectedPages) {
            if (item.id == selectedItem.id) return true;
        }
        return false;
    }

    async handleSave(callback:any) {
        //let componentBinding = this.state.componentFactory.getDefaultBinding();
        //console.log(componentBinding.item);

        let timeInterval = DashboardDateUtil.getTimeInterval();
        let projectId = CacheSettings.getCurrentProject();
        let project = await this.global.dataManager.get("getProject", projectId);
        project.reportJson = JSON.parse(project.reportJson);
        let reportSettings:ReportSettings = this.props.param;
        //let pageSettings = GraphUtil.getAnalyticsPage(CacheSettings.getCurrentPage(), project);

        let selectedPages:any[] = [];
        const cf = this.state.componentFactory;
        const downloadOptions = cf.getDefaultBinding().getProperty("downloadOptions");
        if (downloadOptions == "currentPage") {
            //.let currentPage = GraphUtil.getAnalyticsPage(CacheSettings.getCurrentPage(), project);
            let currentReportPage = ReportUtil.getCurrentReportPage(this.props.param);
            selectedPages.push(currentReportPage)
        } else if (downloadOptions == "allPages") {
            selectedPages = this.state.pages;
        } else if (downloadOptions == "selectedPages") {
            selectedPages = this.state.selectedPages;
        }

        for (let pageSettings of selectedPages) {
            await ExportUtil.downloadReport(reportSettings, pageSettings, timeInterval, project);
        }

        callback(null);
    }

    renderPageRow(page:PageSettings) {
        return [
            <Checkbox color="primary" checked={this.isRowSelected(page)} />,
            page.pageTitle
        ]
    }

    public render() {
        const cf = this.state.componentFactory;
        const downloadOption = cf.getDefaultBinding().getProperty("downloadOptions");
        let downloadOptions = cf.createOptions([
            {id:"currentPage", label:"Current Page"},
            {id:"allPages", label:"All Pages"},
            {id:"selectedPages", label:"Selected Pages"}
        ], "id", "label");

        return cf.renderBox([
            cf.renderBoxPadded(cf.renderSelectField("downloadOptions", "Download Options", downloadOptions)),
            downloadOption == "selectedPages" ? cf.renderTableWithSelection(["Selected", "Page"], this.state.pages, this.renderPageRow.bind(this), this.onRowSelection.bind(this), {fitToContent:true}) : null
        ]);
    }
}

export default dialog(ExportDialog)